import { createContext, useContext } from 'react';

interface AllocationContextProperties {
	refetchAllocationData: () => void;
}

export const AllocationContext = createContext<AllocationContextProperties>({
	// eslint-disable-next-line
	refetchAllocationData: () => {},
});

export const useAllocationContext = () => useContext(AllocationContext);
